export default __webpack_public_path__ + "static/media/GrooveTube.fff97971.png";